import { Provider } from "@redotech/redo-model/order";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getProvidersForTeam = {
  name: "getProvidersForTeam" as const,
  input: z.object({ teamId: z.string() }),
  output: z.array(createEnum(Provider)),
};
